import { createSelector } from 'reselect';
import { createCachedSelector } from 're-reselect';

import { RootStore } from 'store/reducer';
import { selectAppId } from '../v1/auth/auth.selectors';

const selectTeamsStore = (state: RootStore) => state.teams;

const selectTeamsAreFetched = createSelector(
  selectTeamsStore,
  teams => teams.fetched
);

const selectTeams = createSelector(selectTeamsStore, teams => teams.data);

const selectTeamsList = createSelector(selectTeams, data =>
  Object.values(data)
);

const selectTeamById = createCachedSelector(
  selectTeams,
  (_: RootStore, id: string) => id,
  (data, id) => data[id]
)((_, id) => id);

const selectActiveTeam = createSelector(
  [selectTeamsList, selectAppId],
  (teams, appId) => teams?.find(team => team.dbSchema === appId)
);

export {
  selectTeamsStore,
  selectTeamsAreFetched,
  selectTeams,
  selectTeamsList,
  selectTeamById,
  selectActiveTeam
};
